module.exports = "/static/js/23679bafbbf3febb322b1e522e488e56.png";